import React, { PropsWithChildren, ReactElement, useEffect } from "react";
import styles from "./asideDrawer.module.scss";
import classNames from "classnames";

export const HeaderAsideDrawer = (props: Props): ReactElement => {
  useEffect(() => {
    /**
     * disabled body position fixed
     * it disabled hash url scroll mechanism
     * Emre 14.12.2023
     */
    if (!document) return;
    document.body.style.overflow = props.visible ? "hidden" : "none";
    // document.body.style.position = props.visible ? "fixed" : "unset";
    document.body.style.width = props.visible ? "100%" : "auto";

    return () => {
      document.body.style.overflow = "auto";
      // document.body.style.position = "auto";
      document.body.style.width = "auto";
    };
  }, [props.visible]);

  return (
    <>
      <div
        className={classNames(styles.overlay, {
          [styles.visible]: props.visible,
        })}
        onClick={props.onBackdropClicked}
      ></div>
      <aside
        className={classNames(styles.asideContainer, {
          [styles.visible]: props.visible,
        })}
      >
        {props.children}
      </aside>
    </>
  );
};

interface Props extends PropsWithChildren {
  visible: boolean;
  onBackdropClicked: () => void;
}
